import ACTIONS from '../actionTypes/application'
import ApplicationService from '../../services/ApplicationService'

export const getAllApplications = () => {
  return (dispatch) => {
    dispatch({ type: ACTIONS.START_GET_APP_LIST })

    return ApplicationService.getAllApplications().then((res) => {
      if (res.data) {
        dispatch({ type: ACTIONS.GET_APP_LIST_SUCCESS, payload: res.data })
      } else {
        dispatch({ type: ACTIONS.GET_APP_LIST_FAILED })
      }
    }).catch(() => {
      dispatch({ type: ACTIONS.GET_APP_LIST_FAILED })
    })
  }
}

export const getApplicationById = (appId) => {
  return (dispatch) => {
    dispatch({ type: ACTIONS.START_GET_APP_BY_ID })

    return ApplicationService.getApplicationById(appId).then((res) => {
      if (res.data) {
        dispatch({ type: ACTIONS.GET_APP_BY_ID_SUCCESS, payload: res.data })
      } else {
        dispatch({ type: ACTIONS.GET_APP_BY_ID_FAILED })
      }
    }).catch(() => {
      dispatch({ type: ACTIONS.GET_APP_BY_ID_FAILED })
    })
  }
}

export const updateClientSecret = (releaseId, clientId, secretValue) => {
  return (dispatch) => {
    dispatch({ type: ACTIONS.START_UPDATE_CLIENT_SECRET })

    return ApplicationService.updateClientSecret(releaseId, clientId, secretValue).then((res) => {
      if (res.data) {
        dispatch({ type: ACTIONS.UPDATE_CLIENT_SECRET_SUCCESS, payload: res.data })
        return res.data
      } else {
        dispatch({ type: ACTIONS.UPDATE_CLIENT_SECRET_FAILED })
      }
    }).catch(() => {
      dispatch({ type: ACTIONS.UPDATE_CLIENT_SECRET_FAILED })
    })
  }
}

export const generateClientCertificate = (releaseId, clientId, password) => {
  return (dispatch) => {
    dispatch({ type: ACTIONS.START_GENERATE_CLIENT_CERTIFICATE })

    return ApplicationService.generateClientCertificate(releaseId, clientId, password).then((res) => {
      if (res.data) {
        
        var data = window.URL.createObjectURL(res.data)
        var link = document.createElement('a')
        link.href = data
        link.setAttribute('download', `SoftRigCert.p12`)
        link.click()
  
        // Its necessary to delay revoking the ObjectURL in Firefox
        setTimeout(() => {
          window.URL.revokeObjectURL(data)
        }, 100)

        dispatch({ type: ACTIONS.GENERATE_CLIENT_CERTIFICATE_SUCCESS, payload: res.data })
        return res.data
      } else {
        dispatch({ type: ACTIONS.GENERATE_CLIENT_CERTIFICATE_FAILED })
      }
    }).catch(() => {
      dispatch({ type: ACTIONS.GENERATE_CLIENT_CERTIFICATE_FAILED })
    })
  }
}

export const startSyncApplictionsJob = (platformCode) => {
  return (dispatch) => {
    dispatch({ type: ACTIONS.START_APP_SYNC_JOB })

    return ApplicationService.startSyncApplictionsJob(platformCode).then((res) => {
      if (res.data) {
        dispatch({ type: ACTIONS.START_APP_SYNC_JOB_SUCCESS, payload: res.data })
        return res.data
      } else {
        dispatch({ type: ACTIONS.START_APP_SYNC_JOB_FAILED })
      }
    }).catch(() => {
      dispatch({ type: ACTIONS.START_APP_SYNC_JOB_FAILED })
    })
  }
}